<template>
    <modal ref="modal" :modal-backdrop="true">
        <template #body>
            <div class="text-center">
                <div class="text-gray-700 text-lg">Reagendar consulta</div>
                <div class="mt-4 mb-4">Deseja cancelar o atendimento e liberar novo agendamento para o paciente?</div>
                <button type="button" class="btn-primary-invert font-normal" @click.prevent="close">Cancelar</button>
                <button type="button" class="btn-primary font-normal ml-1" @click.prevent="confirm">Reagendar</button>
            </div>
        </template>
    </modal>
</template>
<script>
import { ref } from 'vue';
import Modal from '@/Shared/Modal/Modal'

export default {
    components: {
        Modal,
    },
    setup(props, context) {
        const url = ref(props.url);
        const item = ref(props.item);

        const modal = ref(null);
        
        const openModalReschedule = (i, u) => {
            url.value = u;
            item.value = i;
            modal.value.showModal = true;
        }

        const closeModalReschedule = () => {
            modal.value.showModal = false;
        }

        return {
            openModalReschedule,
            closeModalReschedule,
            modal,
            item,
            url
        }
    },
    methods: {
        confirm() {
            this.$inertia.put(`${this.url}`, {}, {
                onFinish: () => {
                    this.$emit('confirm', this.item);
                    this.close();
                }
            });
        },
        open() {
            this.$refs.modal.showModal = true;
        },
        close() {
            this.$refs.modal.showModal = false;
        }
    },
}
</script>
<style>
    
</style>